import React, { useEffect, useState, useRef } from "react";
import styles from "./StudentOnboardingFaceRec.module.css";
import FaceRegistration from "../FaceRegistration/FaceRegistrationUpd";
import { ReactComponent as Logo } from "../../images/Aubakirova_logo.svg";

const StudentOnboardingFaceRec = () => {
  const [students, setStudents] = useState([]);
  const [selectedStudent, setSelectedStudent] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredStudents, setFilteredStudents] = useState([]);
  const [faceImages, setFaceImages] = useState({
    front: null,
    left: null,
    right: null,
  });
  const [feedback, setFeedback] = useState("");
  const [showFaceRegistration, setShowFaceRegistration] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [popupType, setPopupType] = useState("");
  const [submissionStatus, setSubmissionStatus] = useState("");
  const searchRef = useRef(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchStudents = async () => {
      try {
        const response = await fetch(
          "https://5zbcsztftk.execute-api.eu-west-1.amazonaws.com/default/GetUserListByPlaceIdEDU",
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              sort_key: "zasa05e1p1",
              emp_category: "Ученик",
              action: "list",
            }),
          }
        );
        const data = await response.json();
        const parsedStudents = JSON.parse(data.body).map((student) => ({
          ...student,
          user_name: decodeUnicodeEscapes(student.user_name),
          user_surname: decodeUnicodeEscapes(student.user_surname),
          grade_letter: decodeUnicodeEscapes(student.grade_letter),
          emp_category: decodeUnicodeEscapes(student.emp_category),
        }));
        setStudents(parsedStudents);
      } catch (err) {
        console.error("Error fetching student data:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchStudents();
  }, []);

  const decodeUnicodeEscapes = (str) => {
    if (!str) return "";
    return str.replace(/\\u([\dA-F]{4})/gi, (match, grp) =>
      String.fromCharCode(parseInt(grp, 16))
    );
  };

  useEffect(() => {
    if (searchTerm.length >= 2) {
      const term = searchTerm.toLowerCase();
      const matches = students.filter((student) => {
        const fullName =
          `${student.user_surname} ${student.user_name}`.toLowerCase();
        return (
          fullName.includes(term) ||
          student.user_surname.toLowerCase().includes(term) ||
          student.user_name.toLowerCase().includes(term)
        );
      });
      setFilteredStudents(matches);
    } else {
      setFilteredStudents([]);
    }
  }, [searchTerm, students]);

  const handleStudentSelect = (student) => {
    setSelectedStudent(student);
    setSearchTerm(`${student.user_surname} ${student.user_name}`);
    setFilteredStudents([]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!selectedStudent || !faceImages.front) {
      setPopupType("error");
      setSubmissionStatus("Выберите ученика и зарегистрируйте лицо");
      setShowPopup(true);
      return;
    }

    const photoArray = [
      faceImages.front,
      faceImages.left,
      faceImages.right,
    ].filter(Boolean);

    const payload = {
      place_id: "zasa05e1p1",
      properties: {
        date_of_birth: selectedStudent.date_of_birth,
        emp_category: "Ученик",
        user_email: selectedStudent.user_email,
        grade: `${selectedStudent.grade_number}${selectedStudent.grade_letter}`,
        grade_number: selectedStudent.grade_number,
        grade_letter: selectedStudent.grade_letter,
        created_type: "manual",
        checkin_status: "onboarded",
        user_gender: selectedStudent.user_gender,
      },
      user_name: selectedStudent.user_name,
      user_surname: selectedStudent.user_surname,
      data_url: photoArray,
    };

    try {
      const res = await fetch(
        "https://ste1h7g7s7.execute-api.eu-west-1.amazonaws.com/LoyaltySystem1/UserRecords",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        }
      );

      if (!res.ok) throw new Error("Ошибка при отправке");

      setPopupType("success");
      setSubmissionStatus("Профильные фото ученика добавлены успешно");
      setShowPopup(true);
    } catch (error) {
      setPopupType("error");
      setSubmissionStatus("Ошибка: " + error.message);
      setShowPopup(true);
    }
  };

  if (showFaceRegistration) {
    return (
      <div className={styles.faceRegistrationContainer}>
        <FaceRegistration
          onComplete={(images) => {
            setFaceImages(images);
            setShowFaceRegistration(false);
          }}
          onCancel={() => setShowFaceRegistration(false)}
        />
      </div>
    );
  }

  if (loading) {
    return (
      <div className={styles.loadingOverlay}>
        <div className={styles.spinner}></div>
        <p className={styles.loadingText}>Загрузка списка учеников...</p>
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <div className={styles.logoContainer}>
        <Logo />
      </div>
      <h1 className={styles.title}>Онбординг учеников</h1>

      <form onSubmit={handleSubmit} className={styles.form}>
        <div className={styles.formGroup}>
          <label>Ученик*</label>
          <div className={styles.searchContainer} ref={searchRef}>
            <input
              type="text"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              placeholder="Введите фамилию или имя"
              className={styles.searchInput}
            />
            {filteredStudents.length > 0 && (
              <ul className={styles.searchResults}>
                {filteredStudents.map((student, idx) => (
                  <li
                    key={`${student.user_surname}-${student.user_name}-${idx}`}
                    className={styles.searchResultItem}
                    onClick={() => handleStudentSelect(student)}
                  >
                    {student.user_surname} {student.user_name}
                  </li>
                ))}
              </ul>
            )}
          </div>
        </div>

        {selectedStudent && (
          <div className={styles.employeeInfo}>
            <h3>Информация об ученике</h3>
            <div className={styles.readOnlyField}>
              <label>Пол</label>
              <input
                type="text"
                value={
                  selectedStudent.user_gender === "Male" ? "Мужской" : "Женский"
                }
                readOnly
              />
            </div>
            <div className={styles.readOnlyField}>
              <label>Дата рождения</label>
              <input
                type="text"
                value={selectedStudent.date_of_birth}
                readOnly
              />
            </div>
            <div className={styles.readOnlyField}>
              <label>Класс</label>
              <input
                type="text"
                value={`${selectedStudent.grade_number}${selectedStudent.grade_letter}`}
                readOnly
              />
            </div>
          </div>
        )}

        <div className={styles.photoSection}>
          <h3>Фотографии*</h3>
          <button
            type="button"
            onClick={() => setShowFaceRegistration(true)}
            className={styles.faceRegistrationButton}
          >
            Зарегистрировать лицо
          </button>
          {faceImages.front && (
            <div className={styles.faceImagesPreview}>
              {["front", "left", "right"].map(
                (angle) =>
                  faceImages[angle] && (
                    <div key={angle} className={styles.faceImageContainer}>
                      <img
                        src={faceImages[angle]}
                        alt={angle}
                        className={styles.faceImage}
                      />
                      <span>
                        {angle === "front"
                          ? "Фронтальное"
                          : angle === "left"
                          ? "Левая"
                          : "Правая"}
                      </span>
                    </div>
                  )
              )}
            </div>
          )}
        </div>

        <div className={styles.formGroup}>
          <label htmlFor="feedback">Комментарий</label>
          <textarea
            id="feedback"
            value={feedback}
            onChange={(e) => setFeedback(e.target.value.slice(0, 200))}
            className={styles.textarea}
            placeholder="Ваш комментарий (необязательно)"
          />
          <div className={styles.charCount}>{feedback.length}/200</div>
        </div>

        <button type="submit" className={styles.submitButton}>
          Отправить
        </button>
      </form>

      {showPopup && (
        <div className={styles.popupOverlay}>
          <div
            className={`${styles.popup} ${
              popupType === "success" ? styles.successPopup : styles.errorPopup
            }`}
          >
            <div className={styles.popupContent}>
              <div className={styles.popupIcon}>
                {popupType === "success" ? "✓" : "!"}
              </div>
              <h3>{popupType === "success" ? "Успешно!" : "Ошибка"}</h3>
              <p>{submissionStatus}</p>
              <button
                onClick={() => {
                  setShowPopup(false);
                  if (popupType === "success") {
                    setSelectedStudent(null);
                    setFaceImages({ front: null, left: null, right: null });
                    setSearchTerm("");
                    setFeedback("");
                  }
                }}
                className={`${styles.popupButton} ${
                  popupType === "success"
                    ? styles.successButton
                    : styles.errorButton
                }`}
              >
                Закрыть
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default StudentOnboardingFaceRec;
